import { fetchData } from '../../utils';
import { ApiResponse } from '../../types';
import { CAMPAIGN } from './mediaPlanning';

export const getPartners = async (
  countryISO: string | null,
  division: string | null,
  brand: string | null
) => {
  return fetchData<
    ApiResponse<{ partners: string[]; collabPartners: string[] }>
  >(
    `/${CAMPAIGN}/digital-partners?countryISO=${countryISO}&division=${division}&brand=${brand}`
  );
};
